import { Grid, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { VariantsIcon } from '../../assets/icons/icons'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import DownloadAppButton from '../DownloadAppButton/DownloadAppButton';
import { CustomLightButton } from '../MuiStyledItems/CustomButtons';
import { logoURL } from '../../shared/constants';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const VariantsButton = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
        <IconButton onClick={handleOpen} sx={{padding:0}} disableRipple>
            <Stack justifyContent={"center"} alignItems={"center"}>
                <VariantsIcon/>
                <Typography sx={{color:"black"}} variant='customBodyXsCondensed'>variants</Typography>
            </Stack>
        </IconButton>
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box sx={{position: 'absolute' as 'absolute',
                    top: '50%',
                    left: '50%',
                    width: {xs:"80%", lg:"50%", xl:"30%"},
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    border: '1px solid #000',
                    boxShadow: 24,
                    borderRadius: "8px",
                    p: 4, '&:focus-visible':{outline:"none"}, '&:focus':{outline:"none"}}}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item container justifyContent={"center"} pt={3}>
                        {matches ? <img width={"346px"} height={"auto"} src={logoURL} alt="TRYO"/> : <img width={"221px"} height={"auto"} src={logoURL} alt="TRYO"/>}
                    </Grid>
                    <Grid item container justifyContent={"center"} pt={4}>
                        <Typography variant="customBody" align='center'>
                        Like what you see? Want to try more? <br/>
                        Download our app for an even better experience featuring different colorways, virtual try-ons, a larger catalog and more.
                        </Typography>
                    </Grid>
                    <Grid item container justifyContent={"center"} pt={4}>
                        <Grid item container xs={10} sm={9} md={8} lg={6}>
                            <Grid item container xs={12} justifyContent={"center"}>
                                <DownloadAppButton fullWidth/>
                            </Grid>
                            <Grid item container xs={12} justifyContent={"center"} pt={2}>
                                <CustomLightButton fullWidth onClick={handleClose}>got it</CustomLightButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    </>
  )
}

export default VariantsButton